var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"24","height":"24","viewBox":"0 0 24 24","fill":"currentColor"}},[_c('path',{attrs:{"d":"M19,13H5V11H19V13Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }